export default __webpack_public_path__ + "static/live_attribute-dark-8831e92863646a296c2f74d59c3da9b6.png";